/**
 * @generated SignedSource<<172e12a7d33ac7081e742e5fc2dabaf1>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TopicPageAsideQuery$variables = {
  isNavRefreshEnabled: boolean;
  tagUuid: string;
};
export type TopicPageAsideQuery$data = {
  readonly tagByUuid?: {
    readonly " $fragmentSpreads": FragmentRefs<"TopicHeader_data" | "TopicPageSidebar_data">;
  } | null;
};
export type TopicPageAsideQuery = {
  response: TopicPageAsideQuery$data;
  variables: TopicPageAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isNavRefreshEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tagUuid"
},
v2 = [
  {
    "kind": "Variable",
    "name": "uuid",
    "variableName": "tagUuid"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "watching"
},
v6 = {
  "kind": "ScalarField",
  "name": "count"
},
v7 = {
  "kind": "ScalarField",
  "name": "picture"
},
v8 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v9 = [
  (v6/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "TopicPageAsideQuery",
    "selections": [
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tagByUuid",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "TopicHeader_data"
              },
              {
                "kind": "FragmentSpread",
                "name": "TopicPageSidebar_data"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "TopicPageAsideQuery",
    "selections": [
      {
        "condition": "isNavRefreshEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "Tag",
            "kind": "LinkedField",
            "name": "tagByUuid",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "uuid"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              },
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "watcherCount"
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "topContributors",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "aaid"
                          },
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              (v3/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "accountStatus"
                              },
                              (v8/*: any*/),
                              {
                                "concreteType": "ExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "jobTitle"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "TeamConnection",
                "kind": "LinkedField",
                "name": "topTeams",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "TeamEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Team",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "concreteType": "TeamMemberConnection",
                            "kind": "LinkedField",
                            "name": "members",
                            "plural": false,
                            "selections": (v9/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "name": "teamId"
                          },
                          (v5/*: any*/),
                          {
                            "concreteType": "TeamDetails",
                            "kind": "LinkedField",
                            "name": "teamDetails",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "avatarUrl"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "MsteamsConnections",
                "kind": "LinkedField",
                "name": "msteamsChannels",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MsteamsConnectionsRelayPage",
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  }
                ]
              },
              {
                "concreteType": "SlackConnectionConnection",
                "kind": "LinkedField",
                "name": "slackChannels",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "SlackConnectionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "SlackConnection",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "SlackChannel",
                            "kind": "LinkedField",
                            "name": "channel",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "numMembers"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "watchers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "UserPII",
                            "kind": "LinkedField",
                            "name": "pii",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v7/*: any*/),
                              (v8/*: any*/)
                            ]
                          },
                          (v4/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e395dad45366009df8414a4087dd19ac",
    "id": null,
    "metadata": {},
    "name": "TopicPageAsideQuery",
    "operationKind": "query",
    "text": "query TopicPageAsideQuery(\n  $tagUuid: UUID!\n  $isNavRefreshEnabled: Boolean!\n) {\n  tagByUuid(uuid: $tagUuid) @include(if: $isNavRefreshEnabled) {\n    ...TopicHeader_data\n    ...TopicPageSidebar_data\n    id\n  }\n}\n\nfragment ChatIcons_MSTeamsChannels on MsteamsConnections {\n  data {\n    count\n  }\n}\n\nfragment ChatIcons_SlackChannels on SlackConnectionConnection {\n  count\n  edges {\n    node {\n      channel {\n        numMembers\n      }\n    }\n  }\n}\n\nfragment TagChatAppsIcons_data on Tag {\n  msteamsChannels {\n    ...ChatIcons_MSTeamsChannels\n  }\n  slackChannels {\n    ...ChatIcons_SlackChannels\n  }\n}\n\nfragment TagFollowButton on Tag {\n  id\n  uuid\n  name\n  watching\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamAvatarWithFollowButton on Team {\n  id\n  teamId\n  name\n  watching\n  ...TeamAvatar\n}\n\nfragment TopContributors on Tag {\n  topContributors {\n    edges {\n      node {\n        id\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment TopFollowers_data on Tag {\n  uuid\n  ...TagChatAppsIcons_data\n  ...TagFollowButton\n  watcherCount\n  watchers {\n    edges {\n      node {\n        pii {\n          name\n          picture\n          accountId\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment TopTeams on Tag {\n  topTeams {\n    edges {\n      node {\n        id\n        name\n        members {\n          count\n        }\n        ...TeamAvatarWithFollowButton\n      }\n    }\n  }\n}\n\nfragment TopicDescription_data on Tag {\n  uuid\n  description\n}\n\nfragment TopicHeader_data on Tag {\n  name\n  ...TopicName_data\n  ...TopicDescription_data\n  ...TagFollowButton\n}\n\nfragment TopicName_data on Tag {\n  uuid\n  name\n}\n\nfragment TopicPageSidebar_data on Tag {\n  uuid\n  watcherCount\n  ...TagFollowButton\n  topContributors {\n    count\n  }\n  ...TopContributors\n  topTeams {\n    count\n  }\n  ...TopFollowers_data\n  ...TagChatAppsIcons_data\n  ...TopTeams\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b572b01dd624f95d8d78b8b3c4891a5";

export default node;
